/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_PAN_FILES, GET_PAN_FILES } from 'src/actions/panFileActions';

const initialState = {
  items: [],
  isFetching: false,
  message: ''
};

const panFileReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_PAN_FILES: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_PAN_FILES: {
      const { panFiles, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = panFiles;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default panFileReducer;
